/**
 * 이용약관 전문을 보여 주는 모달. `Footer` 의 "이용약관" 링크가 이 모달을 연다.
 * 약관 본문은 CMS 없이 `src/constants/terms.ts` 에 하드코딩되어 있다.
 * `title` prop 을 넘겨 `BaseDialog` 의 기본(헤더 있는) 모드를 쓰므로 ESC·배경 클릭·포커스 트랩은
 * BaseDialog 가 처리한다.
 */
import React from "react";
import { TERMS_OF_SERVICE } from "@/constants/terms";
import BaseDialog from "./BaseDialog";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PolicyModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  return (
    <BaseDialog
      isOpen={isOpen}
      onClose={onClose}
      title="이용약관"
      widthClassName="w-[640px] max-w-[calc(100vw-32px)]"
      containerClassName="bg-white rounded-[10px] shadow-lg p-[32px] h-[700px]"
    >
      {/* 약관에 들어가는 내용들 */}
      <div className="h-[590px] overflow-y-auto pr-4 scrollbar">
        <div className="text-15 text-heading font-normal whitespace-pre-wrap">
          {TERMS_OF_SERVICE}
        </div>
      </div>
    </BaseDialog>
  );
};

export default PolicyModal;
